export const normalize = (text = "") => {
  return text.normalize("NFD").replace(/\p{Diacritic}/gu, "");
};

export const pluralize = (val: number, word: string, plural = `${word}s`) => {
  return [1, -1].includes(Number(val)) ? word : plural;
};

export const join = (
  array?: string[],
  opts?: { separator?: string; lastSeparator?: string },
): string => {
  if (!array) return "";
  if (array.length === 1) return array[0];

  const separator = opts?.separator ?? ", ";
  const lastSeparator = opts?.lastSeparator ?? " e ";
  const last = array.pop();
  return `${array.join(separator)}${last ? `${lastSeparator}${last}` : ""}`;
};

export const uniqueId = (prefix = ""): string =>
  `${prefix}${Date.now().toString(36) + Math.random().toString(36).substr(2)}`;

export const truncate = (text: string, maxLength: number): string => {
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength - 3).trimEnd() + "...";
};
